import { useState } from 'react'
import { classNames } from '@/ui/utils/main'

interface UserAvatarProps {
  displayName: string | null | undefined
  username: string | null | undefined
  avatarUrl?: string | null
  /** 'sm' = w-9 h-9 (header), 'md' = w-10 h-10 */
  size?: 'sm' | 'md'
  className?: string
}

/**
 * Renders the user's profile picture when available, otherwise falls back
 * to a circle with the user's initial. If the image fails to load, the
 * fallback is shown automatically.
 */
export function UserAvatar({
  displayName,
  username,
  avatarUrl,
  size = 'sm',
  className,
}: UserAvatarProps) {
  const [imgError, setImgError] = useState(false)

  const initial = (displayName || username || '?').charAt(0).toUpperCase()
  const sizeClasses = size === 'sm' ? 'w-9 h-9 text-sm' : 'w-10 h-10 text-base'

  if (avatarUrl && !imgError) {
    return (
      <img
        src={avatarUrl}
        alt={displayName || username || ''}
        className={classNames('rounded-full object-cover', sizeClasses, className)}
        onError={() => setImgError(true)}
      />
    )
  }

  return (
    <span
      className={classNames(
        'rounded-full bg-primary flex items-center justify-center text-primary-foreground font-medium',
        sizeClasses,
        className,
      )}
    >
      {initial}
    </span>
  )
}
